/**
 * Created by jonas on 2021-02-02.
 */

import {GameModel} from "@nolimitcity/slot-game/bin/model/GameModel";
import {ISerialGameData, ISerialInitData} from "./data/ISerialData";
import {ApiPlugin} from "@nolimitcity/slot-launcher/bin/plugins/ApiPlugin";
import {SerialParsedInitData} from "./data/SerialParsedInitData";
import {SerialParsedGameData} from "./data/SerialParsedGameData";
import {SerialDataParser} from "./data/SerialDataParser";
import {Serial} from "../Serial";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {APIBetType} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetType";

export class SerialModel extends GameModel<ISerialInitData, ISerialGameData> {

    public parsedInitData:SerialParsedInitData;
    public parsedGameData:SerialParsedGameData;
    public fullReels:string[][];
    public nextSpinPositions:boolean[][];
    public currentSpinPositions:boolean[][];
    public enhancerReelsOpened:boolean[][];
    public isRestore:boolean = false;

    private _parser:SerialDataParser;

    constructor(api:ApiPlugin, triggerEvents:boolean = true) {
        super(api, triggerEvents);
        this._parser = new SerialDataParser();
    }

    protected onInit(data:ISerialInitData):void {
        this.parsedInitData = new SerialParsedInitData(data, this._parser);
        this.enhancerReelsOpened = this.parsedInitData.enhancerReelsOpenedNextSpin;
        this.fullReels = this.parsedInitData.fullReels;
        this.nextSpinPositions = this.parsedInitData.nextSpinPositions;
        this.isRestore = data.isRestoreState;
        super.onInit(data);
    }

    public onGame(data:ISerialGameData):void {
        if (Serial.isActionSpinsActive){
            return;
        }
        this.parsedGameData = new SerialParsedGameData(data, this._parser);
        this.fullReels = this.parsedGameData.fullReels;
        this.nextSpinPositions = this.parsedGameData.nextSpinPositions;
        this.enhancerReelsOpened = this.parsedGameData.enhancerReelsOpenedNextSpin;
        this.isRestore = false;
        super.onGame(data);
    }
}